import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { toast } from "@/components/ui/toast";

export const useShowEmailVerificationToast = () => {
  const searchParams = useSearchParams();
  useEffect(() => {
    const verificationError = searchParams.get("verificationError");
    if (verificationError) {
      toast.error(verificationError);
    }
    const verificationSuccess = searchParams.get("verificationSuccess");
    if (verificationSuccess) {
      toast("Email verification successful");
    }
  }, [searchParams]);
};
